export const emdVocabulary: {
  title: string;
  token: string;
}[] = [
  {
    title: 'Ainet de Besan',
    token: '7000120002',
  },
  {
    title: 'Ar\u00e0nser',
    token: '7000270005',
  },
  {
    title: 'Ara\u00f3s',
    token: '7000330008',
  },
  {
    title: 'Arcavell i la Farga de Moles',
    token: '7000480001',
  },
  {
    title: 'Arestui',
    token: '7000510007',
  },
  {
    title: '\u00c0reu',
    token: '7000640003',
  },
  {
    title: 'Arr\u00f3',
    token: '7000700000',
  },
  {
    title: 'Arr\u00f2s e Vila',
    token: '7000860009',
  },
  {
    title: 'Ars',
    token: '7000990004',
  },
  {
    title: 'Arties e Gar\u00f2s',
    token: '7001030008',
  },
  {
    title: 'Asnurri',
    token: '7001100000',
  },
  {
    title: 'Aub\u00e8rt e Betlan',
    token: '7001250006',
  },
  {
    title: 'Bagergue',
    token: '7001310007',
  },
  {
    title: 'Baiasca',
    token: '7001460009',
  },
  {
    title: 'Baldomar',
    token: '7007560009',
  },
  {
    title: 'Bellaterra',
    token: '7007170005',
  },
  {
    title: 'Bescaran',
    token: '7001590004',
  },
  {
    title: 'Betren',
    token: '7001620002',
  },
  {
    title: 'B\u00edtem',
    token: '7007220002',
  },
  {
    title: 'Campred\u00f3',
    token: '7007380001',
  },
  {
    title: 'Canalda',
    token: '7001780001',
  },
  {
    title: 'Casau',
    token: '7001970005',
  },
  {
    title: 'Civ\u00eds',
    token: '7002010007',
  },
  {
    title: 'Durro i Sara\u00eds',
    token: '7002180001',
  },
  {
    title: 'Escunhau e Casarilh',
    token: '7002230008',
  },
  {
    title: 'Espui',
    token: '7002390004',
  },
  {
    title: "l'Estartit",
    token: '7007690004',
  },
  {
    title: 'Fontllonga i Ametlla',
    token: '7002440003',
  },
  {
    title: 'Gausac',
    token: '7002570005',
  },
  {
    title: 'Gerb',
    token: '7002600000',
  },
  {
    title: 'Gessa',
    token: '7002760009',
  },
  {
    title: "la Gu\u00e0rdia d'Ares",
    token: '7002820002',
  },
  {
    title: 'Isil i Al\u00f3s',
    token: '7006300000',
  },
  {
    title: 'Jes\u00fas',
    token: '7005110007',
  },
  {
    title: 'Josa de Cad\u00ed',
    token: '7002950006',
  },
  {
    title: 'Manyanet',
    token: '7003090004',
  },
  {
    title: 'Montenartr\u00f3',
    token: '7003160009',
  },
  {
    title: 'els Muntells',
    token: '7003210007',
  },
  {
    title: 'Os de Civ\u00eds',
    token: '7003370005',
  },
  {
    title: 'Pi',
    token: '7003420002',
  },
  {
    title: 'Picamoixons',
    token: '7006240003',
  },
  {
    title: 'el Pla de la Font',
    token: '7003550006',
  },
  {
    title: 'Raimat',
    token: '7006610007',
  },
  {
    title: 'Rocallaura',
    token: '7006770005',
  },
  {
    title: 'Sant Joan Fumat',
    token: '7003740003',
  },
  {
    title: 'Sant Mart\u00ed de Torroella',
    token: '7003800000',
  },
  {
    title: 'Sant Miquel de Baleny\u00e0',
    token: '7007750006',
  },
  {
    title: 'Santa Maria de Mei\u00e0',
    token: '7003930008',
  },
  {
    title: 'Seana',
    token: '7006960009',
  },
  {
    title: 'Sellui',
    token: '7004070005',
  },
  {
    title: 'Senet',
    token: '7004140003',
  },
  {
    title: "la Serra d'Almos",
    token: '7007430008',
  },
  {
    title: 'Sorpe',
    token: '7006450006',
  },
  {
    title: 'Soss\u00eds',
    token: '7004290004',
  },
  {
    title: 'Sucs',
    token: '7004350006',
  },
  {
    title: 'el Talladell',
    token: '7007000000',
  },
  {
    title: 'Ta\u00fas',
    token: '7004400000',
  },
  {
    title: 'Tornafort',
    token: '7006830008',
  },
  {
    title: 'Tred\u00f2s',
    token: '7004530008',
  },
  {
    title: 'Unha',
    token: '7006580001',
  },
  {
    title: 'Valldoreix',
    token: '7004660009',
  },
  {
    title: 'Vila i Vall de Castellb\u00f2',
    token: '7004720002',
  },
  {
    title: 'Vilac',
    token: '7004880001',
  },
  {
    title: 'Vilamitjana',
    token: '7004910007',
  },
  {
    title: 'V\u00edllec i Estana',
    token: '7005040003',
  },
];
